export class OrderListModel {
    consumerId: string;
    orderCreateDate: string;
    orderId: string;
    orderNumber: string;
    orderItems?: (OrderListItemModel)[] | null;
    sellType: string;

    beniName: string;
    productCategory: string;
    purposeType: string;
    partnerName: string;

    orderStatus: string;
    kycStatus: string;
    paymentStatus: string;
    complianceStatus: string;
}

export class OrderListItemModel {
    bidRate: number;
    currencyAmount: number;
    currencyCode: string;
    id: string;
    orderItemId: string;
    product: string;
    purpose: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/order/OrderListModel.ts